const Theme = {
  "--white": "#ffffff",
  "--very-light-gray": "#f3f3f3",
  "--light-gray": "#eaebeb",
  "--gray": "#dfe0e1",
  "--mid-gray": "#cacccd",
  "--carbon": "#b5b7b9",
  "--charcoal": "#231f20",
  "--light-purple": "#ae95eb",
  "--mid-purple": "#9675e1",

  "--button-padding": "0.5em",

  "--font-size": "16px",
  "--font-family": "Helvetica, Arial, Sans-Serif",
  "--regular-font": "normal 16px/24px var(--font-family)",

  "--primary-background-color": "var(--white)",
  "--primary-font-color": "var(--charcoal)",
  "--title-font-color": "var(--white)",

  "--alternating-bg-odd": "var(--very-light-gray)",
  "--alternating-bg-even": "var(--white)",
};

export default Theme;
